import type { InterventionsBatchEditUsersProps } from "./interventions-batch-edit-users.type";

import { useTranslation } from "react-i18next";

import BatchEditForm from "@/modules/batch-edit-form";
import UsersSelect from "@/modules/users/users-select";

import { useInterventionsBatchEditUsers } from "./interventions-batch-edit-users.hook";

const InterventionsBatchEditUsers = ({
  interventions,
}: InterventionsBatchEditUsersProps) => {
  const { t } = useTranslation();
  const {
    form,
    fieldName,
    initialValue,
    onFormChange,
    onFormSubmit,
    isPending,
    hasChanges,
    hasError,
    fieldApiError,
  } = useInterventionsBatchEditUsers(interventions);

  return (
    <BatchEditForm
      modelKey="intervention"
      form={form}
      fieldName={fieldName}
      initialValue={initialValue}
      onFormChange={onFormChange}
      onFormSubmit={onFormSubmit}
      hasChanges={hasChanges}
      isPending={isPending}
      hasError={hasError}
    >
      <UsersSelect
        name={fieldName}
        label={t("intervention:batchEdit.users.label")}
        placeholder={t("intervention:batchEdit.users.label")}
        validateStatus={fieldApiError ? "error" : "success"}
        help={fieldApiError}
      />
    </BatchEditForm>
  );
};

export default InterventionsBatchEditUsers;
